import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { requestAutocompleteDkws } from '../../api';
import DHPic from '../../images/Dr-haiel3.png';
import { Grid } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    maxWidth: 345
  },
  media: {
    height: 140
  },
  avt: {
    marginBottom: 20,
    '&:before': {
      backgroundImage: `url(${DHPic})`,
      backgroundSize: '30px 30px',
      backgroundRepeat: 'no-repeat',
      content: '""',
      position: 'absolute',
      left: 10,
      width: 30,
      height: 30
    }
  },
  bot: {
    maxWidth: 445
  }
});

const AddressInput = ({ content, onUserInput, isLastMessage }) => {
  const classes = useStyles();

  const [displayForm, setDisplayForm] = React.useState('block');
  const [street, setStreet] = React.useState('');
  const [city, setCity] = React.useState('');
  const [state, setState] = React.useState('');
  const [zip, setZip] = React.useState('');

  // const [dkw, setDkw] = React.useState('');
  // const [dkwsBeginWithInput, setDkwsBeginWithInput] = React.useState([]);

  // const handleUserInput = async (e) => {
  //   if (e.target.value.length > 2) {
  //     const result = await requestAutocompleteDkws(e.target.value);
  //     setDkwsBeginWithInput([...result]);
  //   }
  // };

  const handleSubmit = () => {
    setDisplayForm('none');
    onUserInput('user submit', `${street} ${city} ${state} ${zip} `);
  };
  return (
    <Fragment>
      <div className={classes.avt}>_</div>
      <Card
        className={(classes.root, classes.bot)}
        style={{
          marginBottom: '20px',
          backgroundColor: '#E3F5F7'
        }}
      >
        <CardContent>
          <Typography variant="h5" component="h2" style={{ fontSize: '1rem' }}>
            {content}
          </Typography>
        </CardContent>
        <div style={{ display: displayForm, padding: 12 }}>
          <FormControl className={classes.margin}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  label="Street"
                  variant="outlined"
                  value={street}
                  onChange={(e) => { setStreet(e.target.value) }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="City"
                  variant="outlined"
                  value={city}
                  onChange={(e) => { setCity(e.target.value) }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="State"
                  variant="outlined"
                  value={state}
                  onChange={(e) => { setState(e.target.value) }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label="Zip Code"
                  variant="outlined"
                  value={zip}
                  onChange={(e) => { setZip(e.target.value) }}
                />
              </Grid>
            </Grid>
          </FormControl>
          <FormControl className={classes.margin}>
            <Button
              style={{ marginTop: 16, marginBottom: 16 }}
              variant="contained"
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </FormControl>
        </div>
      </Card>
    </Fragment>
  );
};
AddressInput.propTypes = {
  content: PropTypes.string.isRequired,
  onUserInput: PropTypes.func.isRequired,
  isLastMessage: PropTypes.bool.isRequired
};

export default AddressInput;



// WEBPACK FOOTER //
// ./src/components/AddressInput/AddressInput.js